import { render } from "./AssignDistribution.vue?vue&type=template&id=4d3a109a&scoped=true"
import script from "./AssignDistribution.vue?vue&type=script&lang=js"
export * from "./AssignDistribution.vue?vue&type=script&lang=js"

import "./AssignDistribution.vue?vue&type=style&index=0&id=4d3a109a&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d3a109a"]])

export default __exports__